import React from 'react';

function DottedLine({ startX, startY, angle, distance }) {
    return (
      <div
        style={{
          position: 'absolute',
          top: `${startY}px`,
          left: `${startX}px`,
          width: `${distance}px`,
          height: '0px',
          borderTop: '2px dashed red',
          transform: `rotate(${angle}deg)`,
          transformOrigin: '0 0',
          zIndex: 1000,
        }}
      />
    );
}

export default DottedLine;